/* eslint-disable @next/next/no-img-element */

import React from 'react';

import styles from './styles.module.scss'
import Points from '../Points';

interface PointsSectionProps {
  header: string;
  text: string | JSX.Element;
  pointsHeader?: string;
  points: string[];
  switchDirection?: boolean;
}

export default function PointsSection({ 
  header, text,
  pointsHeader, points,
  switchDirection
} : PointsSectionProps) {
  return (
    <div className={`${styles.pointsSection} ${switchDirection && styles.oneDirection}`}>
      <div className={styles.textHolder}>
        <h1 className={`${styles.textSectionHeader} perfect-header`}>{header}</h1>
        
        <p className={styles.textSectionText + " text"}>{ text }</p>
      </div>

      <div className={styles.pointsHolder}>
        <Points 
          className={styles.points}
          header={pointsHeader}
          points={points}
        />
      </div>
    </div>
  )
};
